<template>
  <div class="mb-4">
    <h6 class="text-uppercase font-weight-bold text-secondary mb-3">
      <i class="fas fa-sliders-h mr-1"></i> Report Sections
    </h6>
    <div class="row">
      <div class="col-md-6 col-12 mb-2" v-for="toggle in toggles" :key="toggle.key">
        <div class="d-flex align-items-center justify-content-between border rounded px-3 py-2"
             :class="value[toggle.key] ? 'border-primary bg-light' : 'border-light bg-white'">
          <div>
            <span class="font-weight-medium">{{ toggle.label }}</span>
            <small class="d-block text-muted">{{ toggle.description }}</small>
          </div>
          <b-form-checkbox
            :checked="value[toggle.key]"
            switch
            size="lg"
            @change="(val) => onToggleChange(toggle.key, val)"
            class="ml-2 flex-shrink-0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncidentReportSectionToggles',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      allToggles: [
        {
          key: 'includeAISummary',
          label: 'AI-Written Summary',
          description: 'AI generates a professional incident narrative'
        },
        {
          key: 'includeQRCodes',
          label: 'Scan Codes (QR Codes)',
          description: 'Add QR codes to photos for quick access'
        },
        {
          key: 'includeMediaCollectionQR',
          label: 'All-Files QR Code',
          description: 'Cover page QR that links to all report media at once'
        },
        {
          key: 'includeTableOfContents',
          label: 'Table of Contents',
          description: 'Navigation page at the beginning of the report'
        },
        {
          key: 'includeSopSection',
          label: 'Procedure Checklist',
          description: 'Include SOP questions and responses'
        },
        {
          key: 'includeInsuranceClaims',
          label: 'Insurance Claims',
          description: 'Attach all associated insurance claim details'
        },
        {
          key: 'includePeopleInsurance',
          label: 'Include people\'s insurance',
          description: 'Adds carrier, policy type and claim # under each person.'
        },
        {
          key: 'includeExpenses',
          label: 'Damage Related Expenses',
          description: 'Include damage-related expenses with running total'
        },
        {
          key: 'includeDocumentAppendix',
          label: 'Document Appendix',
          description: 'List selected documents with QR codes for quick access'
        },
        {
          key: 'includeVideos',
          label: 'Include Videos Section',
          description: 'Show video thumbnails and links in the report'
        },
        {
          key: 'includeSignaturePage',
          label: 'Signature Page',
          description: 'Add a blank signature page at the end'
        },
        {
          key: 'includeConfidentialWatermark',
          label: 'Mark as Confidential',
          description: 'Adds a CONFIDENTIAL watermark to every page'
        }
      ]
    }
  },
  computed: {
    canViewQRCode () {
      const featureEnabled = this.$store.getters['featureFlags/isEnabled']('media.qrcode-sharing')
      return featureEnabled &&
             (this.$store.state.loggedInUserPermissions && this.$store.state.loggedInUserPermissions.viewQRCode === true)
    },
    toggles () {
      return this.allToggles.filter(t =>
        (t.key !== 'includeQRCodes' && t.key !== 'includeMediaCollectionQR') || this.canViewQRCode
      )
    }
  },
  methods: {
    onToggleChange (key, val) {
      this.$emit('input', { ...this.value, [key]: val })
    }
  }
}
</script>
